import { Box, Button, Stack, SxProps, Typography } from '@mui/material';
import React from 'react';
import { ActionProperties } from '@molecules/ActionItem';

function PageHeader({
  children,
  subHeader,
  action,
  sx,
}: Readonly<{
    children: React.ReactNode;
    subHeader?: React.ReactNode;
    action?: ActionProperties;
    sx?: SxProps;
}>) {
  return (
    <Box
      sx={{
        pb: 3,
        mb: 3,
        borderBottom: '1px solid',
        borderColor: 'divider',
        ...sx,
      }}>
      <Stack spacing={2}>
        <Typography
          variant="h4"
          fontWeight={700}
          component="h1"
          color="text.primary"
          sx={{
            fontSize: { xs: '1.75rem', sm: '2rem' },
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
          }}>
          {children}
        </Typography>
        
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
          spacing={{ xs: 2, sm: 0 }}
          gap={2}>
          {subHeader && (
            <Typography
              variant="body1"
              component="h2"
              color="text.secondary"
              sx={{
                fontSize: { xs: '0.875rem', sm: '1rem' },
                fontWeight: 400,
                flexGrow: 1,
              }}>
              {subHeader}
            </Typography>
          )}
          
          {action && (
            <Button
              size="medium"
              variant="contained"
              disabled={action.disabled}
              onClick={action.onClick}
              startIcon={action.icon}
              sx={{
                fontWeight: 600,
                textTransform: 'none',
                px: 3,
                py: 1,
                borderRadius: 1.5,
                boxShadow: 1,
                '&:hover': {
                  boxShadow: 2,
                },
              }}>
              {action.label}
            </Button>
          )}
        </Stack>
      </Stack>
    </Box>
  );
}

export default PageHeader;
